<section *ngIf="hideLoader; else Loader">
  <img src="./assets/images/card-icon.png" alt="" />

  <section class="dots">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </section>
  <h1>Placing order</h1>

  <p class="typog-body">This can take up to 60 seconds to complete.</p>

  <section *ngIf="showRefreshBox" class="refresh">
    <p class="typog-body">
      If the page doesn't change automatically, <br />
      <a href="javascript:window.location.href=window.location.href"
        >try refreshing.</a
      >
    </p>
  </section>
</section>

<ng-template #Loader>
  <app-loader></app-loader>
</ng-template>
